export default "__VITE_ASSET__BCWjYVV8__"